// extracted by mini-css-extract-plugin
export default {"congratulations":"congratulations_congratulations__bk6qP","button":"congratulations_button__-LFbP"};